module.exports = __webpack_public_path__ + "5ac8a6f508e907491a795a146122ae94.jpg";